import React, { useEffect, useState, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { motion, AnimatePresence } from 'framer-motion'
import localforage from 'localforage'
import { useTranslation } from 'react-i18next'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { AccountWrapper, Field, SecureField, Awaiter } from './components'
import * as requests from '#src/requests'
import { useRecoilState, useRecoilValue } from 'recoil'
import {
  accountEmailState,
  tokenState,
} from '#state'

const emailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/

export default function Login (props) {
  const [email, setEmail] = useRecoilState(accountEmailState)
  const [token, setToken] = useRecoilState(tokenState)

  const { t } = useTranslation()
  const navigate = useNavigate()

  const [pass, setPass] = useState('')
  const [loginError, setLoginError] = useState('')
  const [passwordError, setPasswordError] = useState('')
  const [showErrors, setShowErrors] = useState(false)
  const [isAwaiting, setIsAwaiting] = useState(false)

  useEffect(() => {
    if (email === '') {
      const errMessage = t('account.errors.emptyEmail')
      setLoginError(errMessage)
    } else if (!email.match(emailformat)) {
      const errMessage = t('account.errors.incorrectEmail')
      setLoginError(errMessage)
    } else {
      setLoginError('')
    }
    // check password
    if (pass === '') {
      const errMessage = t('account.errors.emptyPass')
      setPasswordError(errMessage)
    } else {
      setPasswordError('')
    }
  }, [email, pass])

  const check = async event => {
    // app root reload \ rerender fix
    event.preventDefault()
    if (loginError || passwordError) {
      console.log('login or pass incorrect')
      setShowErrors(true)
    } else {
      setIsAwaiting(true)
      const result = await requests.login(email, pass)
      setIsAwaiting(false)
      if (!result.success) {
        console.log('login error', result)
        if (result.error) {
          setShowErrors(true)
          const errMessage = t(`account.errors.${result.error}`)
          console.log('errMessage', errMessage)
          setPasswordError(errMessage)
        } else {
          setPasswordError('')
        }
      } else {
        setShowErrors(false)
        console.log('login success', result)
        setToken(result.token)
        try {
          await localforage.setItem('token', result.token)
        } catch (err) {
          console.log('save token error', err)
        }
        navigate('/')
        // trackEvent('Login')
        // navigate('/', { replace: true })
      }
    }
  }

  return (
    <>
      <AccountWrapper>
        <Grid
          component='form'
          container
          direction='column'
          alignItems='center'
          justifyContent='space-evenly'
          sx={{
            px: 5,
            py: 5,
            borderRadius: 2,
            // border: '1px solid',
            // borderColor: 'action.selected'
          }}
          onSubmit={check}
        >
          <Grid
            item
            container
            direction='column'
            alignItems='center'
            justifyContent='space-between'
            sx={{
              minHeight: '15vh'
            }}
          >
            <Typography textAlign='center' variant='h4'>{t('account.login.title')}</Typography>

            <Grid item container alignItems='center' justifyContent='center'>
              <Typography>{t('account.login.createPre')}</Typography>
              <Button
                sx={{ textTransform: 'none', cursor: 'pointer' }}
                onClick={() => {
                  navigate('/account/register', { replace: true })
                }}
              >
                <Typography>{t('account.login.createLink')}</Typography>
              </Button>
            </Grid>
          </Grid>

          <Grid
            item
            container
            direction='column'
            alignItems='stretch'
            justifyContent='space-evenly'
            sx={{
              minHeight: '26vh'
            }}
          >
            <Field
              value={email}
              setValue={setEmail}
              label={t('account.login.emailLabel')}
              placeholder={t('account.login.emailPlaceholder')}
              errorMessage={loginError}
              showErrors={showErrors}
            />
            <SecureField
              value={pass}
              setValue={setPass}
              label={t('account.login.passLabel')}
              placeholder={t('account.login.passPlaceholder')}
              type='password'
              autoComplete='current-password'
              errorMessage={passwordError}
              showErrors={showErrors}
              secureTextEntry
            />
          </Grid>
          <Grid
            item
            container
            direction='column'
            alignItems='center'
            justifyContent='space-between'
            sx={{
              minHeight: '25vh'
            }}
          >
            <Button fullWidth variant='contained' size='large' type='submit'>
              <Typography>{t('account.login.mainBtn')}</Typography>
            </Button>
            <Button
              sx={{ textTransform: 'none', cursor: 'pointer' }}
              onClick={() => {
                console.log('forgot password')
                navigate('/account/resetpass', { replace: true })
              }}
            >
              <Typography>{t('account.login.resetLink')}</Typography>
            </Button>
            <Button
              fullWidth
              variant='outlined'
              size='large'
              onClick={() => {
                navigate('/account/otclogin', { replace: true })
              }}
            >
              <Typography>{t('account.login.otcBtn')}</Typography>
            </Button>
          </Grid>
        </Grid>
      </AccountWrapper>
      <Awaiter isAwaiting={isAwaiting} />
    </>
  )
}
